import { UIGameMapController } from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapController.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { MOBILE_ZOOM_BOOST } from '@colonist/ui-game';
export class UIMGameMapController extends UIGameMapController {
    centerMapView() {
        var _this_mapView_plugins_get;
        if (UIUtilsEjsVariables.isUserOnTabletApp) return;
        const scaleFactor = this.mapView.scale.x;
        const clamp = (_this_mapView_plugins_get = this.mapView.plugins.get('clamp')) === null || _this_mapView_plugins_get === void 0 ? void 0 : _this_mapView_plugins_get.options;
        let horzOffset = 0;
        if (clamp == undefined || typeof clamp.left == 'boolean' || typeof clamp.right == 'boolean') {
            horzOffset = 0;
        } else {
            var _clamp_left, _clamp_right;
            horzOffset = Math.round((_clamp_left = clamp === null || clamp === void 0 ? void 0 : clamp.left) !== null && _clamp_left !== void 0 ? _clamp_left : 0) + Math.round((_clamp_right = clamp === null || clamp === void 0 ? void 0 : clamp.right) !== null && _clamp_right !== void 0 ? _clamp_right : 0);
        }
        this.mapView.left = -this.mapView.screenWidth / 2 / scaleFactor + horzOffset / 2;
        this.mapView.top = -this.mapView.screenHeight / 1.75 / scaleFactor;
    }
    scaleMapView() {
        if (UIUtilsEjsVariables.isUserOnTabletApp) return;
        this.mapView.scale.set(this.getFitScale() * MOBILE_ZOOM_BOOST);
    }
    constructor(uiGameManager){
        super(uiGameManager, false);
    }
}
